import React from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'

// import data from './data'
import maximizeIcon from './assets/maximizeIcon.svg'
import closeIcon from './assets/closeIcon.svg'
import iconBtn from '../../assets/icons/project.svg'
import Form from '../../components/Form'

import styles from './styles.module.sass'
import url from '../../config/url'
import Axios from 'axios'

export default class List extends React.Component {
  state = {
    modalIndex: null,
    formModal: null,
    photos: [],
  }

  componentDidMount = () => {
    document.addEventListener('keydown', this.keyDown)
  }
  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.keyDown)
  }
  keyDown = e => {
    if (e.keyCode === 39) {
      this.next()
    }
    if (e.keyCode === 37) {
      this.previous()
    }
  }
  getPortfolio = async id => {
    const { data, status } = await Axios({
      method: 'get',
      url: url + `api/admin/project-img?project_id=${id}`,
    })
    if (status === 200) {
      this.setState({ photos: data })
    }
  }

  next = () => {
    this.slider.slickNext()
  }

  previous = () => {
    this.slider.slickPrev()
  }
  // const [modalIndex, setModalIndex] = useState(null)
  // const [formModal, formHandle] = useState(null)
  setModalIndex = modalIndex => this.setState({ modalIndex })
  formHandle = val => this.setState({ formModal: val })
  render() {
    const { formModal, photos = [] } = this.state
    const { data = [] } = this.props

    return (
      <>
        {data
          .sort((a, b) => a.position - b.position)
          .map(({ id, name, image, logo, description, list = [] }, i) => (
            <React.Fragment key={i}>
              <Row noGutters key={i} className={styles.project}>
                <Col
                  onClick={() => {
                    this.getPortfolio(id)
                  }}
                  md={4}
                  sm={12}
                  style={{ backgroundImage: `url(${url + image})` }}
                  className={styles.project__image}>
                  <Maximize src={maximizeIcon} alt="" />
                </Col>

                <Col md={1} sm={0}>
                  <Line className={styles.project__line} />
                </Col>

                <Col md={5} style={{ position: 'relative' }}>
                  <h3 style={{ marginBottom: 15, fontSize: 20 }}>{name}</h3>
                  <div
                    style={{ marginBottom: 10, fontSize: 16 }}
                    dangerouslySetInnerHTML={{ __html: description }}></div>
                  <div className={styles.descr}>Выполненная комплектация:</div>
                  <ul className={styles.project__ul}>
                    {list.map((elem, j) => (
                      <li key={j}>• {elem}</li>
                    ))}
                  </ul>
                  <div
                    className={styles.project__btn}
                    onClick={() => this.formHandle(true)}
                    size="lg"
                    variant="primary">
                    <img src={iconBtn} alt="" />
                  </div>
                </Col>

                <Col md={2}>
                  <Logo
                    className={styles.project__logo}
                    src={url + logo}
                    alt="Logo"
                  />
                </Col>
              </Row>
            </React.Fragment>
          ))}
        {Boolean(photos) && (
          <Modal isOpen={Boolean(formModal)}>
            <div className="modal-overlay"></div>
            <div className="body-form">
              <Close onClick={() => this.formHandle(null)}>
                <Maximize
                  src={closeIcon}
                  onClick={() => this.formHandle(null)}
                />
              </Close>
              <Form
                title="Хотите также? </br> Свяжитесь с нами!"
                btnText="Связаться с нами!"
                subject="Проекты"
                callBack={() => this.setState({ photos: [] })}
              />
            </div>
          </Modal>
        )}

        <Modal isOpen={photos.length}>
          <div className="modal-overlay"></div>
          <div className="body">
            <Close onClick={() => this.formHandle(null)}>
              <Maximize
                src={closeIcon}
                onClick={() => this.setState({ photos: [] })}
              />
            </Close>
            <Slider ref={c => (this.slider = c)} {...settings}>
              {photos.map(({ img }, key) => (
                <div key={key}>
                  <SliderImage src={url + img} />
                </div>
              ))}
            </Slider>
          </div>
        </Modal>
      </>
    )
  }
}

const settings = {
  arrows: true,
  adaptiveHeight: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const SliderImage = styled.div`
  width: 100%;
  min-height: 60vh;
  max-height: 500px;
  background: transparent url(${props => props.src}) no-repeat center center;
  background-size: contain;
  display: block;
`
const Logo = styled.div`
  background: #fff url(${props => props.src}) no-repeat center center;
  width: 150px;
  height: 150px;
  margin: auto;
  background-size: 120px auto;
  border-radius: 50%;
`
const Maximize = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 5%;
  bottom: 5%;
`
const Line = styled.div`
  width: 3px;
  height: 100%;
  background-color: #fff;
  margin: 0 auto;
`

const Modal = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: ${props => (props.isOpen ? 9999 : -1)};
  display: flex;
  justify-content: center;
  align-items: center;
  & .modal-overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    backdrop-filter: blur(5px);
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100vh;
  }
  & .body {
    width: 80%;
    max-width: 800px;
    min-width: 200px;
    max-height: 600px;
    border-radius: 8px;
    position: absolute;
  }
  & .body-form {
    min-width: 260px;
    -ms-transform: translate(-50%, -50%);
    border-radius: 8px;
    /* top: 50%; */
    position: absolute;
  }
`
const Close = styled.div`
  color: #fff;
  z-index: 9999;
  font-size: 30px;
  position: absolute;
  width: 25px;
  height: 25px;
  right: -25px;
  cursor: pointer;
  top: -25px;
`
